<div class="general flex flex-col justify-between h-full">
	<app-loading-spinner *ngIf="loading"></app-loading-spinner>
	<div class="contentGeneral h-full flex" *ngIf="!loading">
		<div class="w-[calc(40%)] flex justify-center items-center flex-col">
			<img
				imgNotFound
				src="{{ group.picture }}"
				style="width: 200px; height: 200px"
				class="object-contain"
			/>
			<div>
				<div class="flex mt-4 mb-4">
					<label class="titleGroupSelect" for=""> {{ translateGeneral.textName }}: </label>
					<span class="ml-4 nameGroupSelect">{{ group.name }}</span>
				</div>
				<div class="flex mb-4">
					<label class="titleGroupSelect" for=""> {{ translateGeneral.textId }}: </label>
					<span class="ml-4 nameGroupSelect">
						{{ group.sk.split(':')[0] }}
					</span>
				</div>
				<div class="flex mb-4">
					<label class="titleGroupSelect" for=""> {{ translateGeneral.textEmail }}: </label>
					<span class="ml-4 nameGroupSelect">
						{{ group.emailTemplade || '' }}
					</span>
				</div>
			</div>
		</div>
		<div class="w-[calc(20%)] h-full justify-center items-center flex">
			<hr class="lineCenter h-3/4" />
		</div>
		<div class="w-[calc(40%)] flex flex-col justify-center items-center">
			<div class="flex pt-5">
				<div class="mr-3">
					<img width="45px" src="../../../../assets/icon/subGroups.svg" alt="" />
				</div>
				<div>
					<span class="numberSubGroups">{{ group.subGroups }}</span>
				</div>
				<div class="ml-3">
					<span class="textSubGroups"
						>sub<br />
						{{ translateGeneral.textGroups }}
					</span>
				</div>
			</div>
			<div class="flex mt-12">
				<div class="mr-3">
					<img width="45px" src="../../../../assets/icon/users.svg" alt="" />
				</div>
				<div>
					<span class="numberSubGroups">{{ group.users }}</span>
				</div>
				<div class="ml-3">
					<span class="textSubGroups"
						>total<br />
						{{ translateGeneral.textUser }}
					</span>
				</div>
			</div>
			<div
				class="grid grid-cols-2 gap-1 mt-10 h-36 overflow-y-auto overflow-x-hidden"
				*ngIf="group.sk"
			>
				<div class="flex" *ngFor="let statuRole of group.statusUser">
					<div>
						<span class="numberRole">{{ statuRole.roles.length }} </span>
					</div>
					<div class="ml-3">
						<span class="nameRole"> {{ statuRole.name }}</span>
						<div
							class="colorStatus"
							[ngStyle]="{
								'background-color': statuRole.color
							}"
						></div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="buttons flex items-center justify-end h-16 pr-4">
		<button class="px-3" (click)="updateGroup()">
			<mat-icon class="text-primary-color mr-2"> edit </mat-icon>
			<span class="font-lato"> {{ translateGeneral.buttonEdit }} </span>
		</button>
	</div>
</div>
